// extracted by mini-css-extract-plugin
module.exports = {"EducationBlob":"C4Vmr736","educationPicture":"_3KP7y55z","secondaryContainer":"_2nU3b-OR","secondaryDetailsOne":"_2MyHIZ1z","secondaryDetailsTwo":"_1txWxFLo","educationDetails":"_1KkNXvYH","educationName":"_2ogmx5WV","educationDegree":"rmHVBDm0","educationYears":"_3YrBUHoL","educationTitle":"_2oVZSter","gpa":"_25ptQrQM"};
    if(module.hot) {
      // 1754514971478
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  